import React, { useState, useEffect } from 'react';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [galleryImages, setGalleryImages] = useState([]);

  // Local images klasöründeki tüm fotoğrafları yükle
  useEffect(() => {
    // public/images klasöründeki seçili dosyalar (4 tane hariç)
    const imageFiles = [
      '168980D4-B1FE-44EA-AB7B-E2F4F22026DF.jpeg',
      '2022-06-22-2.jpg',
      '2022-06-22.jpg',
      '2023-01-27.jpg',
      '55486DD8-1216-4A6B-BBCD-F76DC9598723.jpeg',
      '6DD61E5D-CC33-4DF7-A9DC-1025C9EDFCC0.jpeg',
      'DAE83124-E01B-4383-AB03-D4962979E994.jpeg',
      'F52FE538-0341-4086-9F48-300DB4856B99.jpeg',
      'unnamed-2.jpg',
      'unnamed.jpg'
    ];

    const images = imageFiles.map((filename, index) => ({
      id: index + 1,
      filename: filename,
      src: `/images/${filename}`,
      alt: `Işıltı Saz Evi`,
      title: '',
      description: ''
    }));

    setGalleryImages(images);
    console.log('Galeri fotoğrafları yüklendi:', images.length);
  }, []);

  console.log('Gallery render - fotoğraf sayısı:', galleryImages.length);

  const openImageModal = (image) => {
    setSelectedImage(image);
  };

  const closeImageModal = () => {
    setSelectedImage(null);
  };

  const nextImage = () => {
    const currentIndex = galleryImages.findIndex(img => img.id === selectedImage.id);
    const nextIndex = (currentIndex + 1) % galleryImages.length;
    setSelectedImage(galleryImages[nextIndex]);
  };

  const prevImage = () => {
    const currentIndex = galleryImages.findIndex(img => img.id === selectedImage.id);
    const prevIndex = currentIndex === 0 ? galleryImages.length - 1 : currentIndex - 1;
    setSelectedImage(galleryImages[prevIndex]);
  };





  return (
    <div className="container py-5">
      {/* Header */}
      <div className="row">
        <div className="col-12">
          <div className="text-center mb-5">
            <h1 className="display-4 fw-bold mb-4">
              <i className="bi bi-images me-3 text-primary"></i>
              Galeri
            </h1>
            <p className="lead text-muted">
              Atölyemizden kareler ve üretim süreçlerimiz ({galleryImages.length} fotoğraf)
            </p>
          </div>
        </div>
      </div>

      {/* Gallery Grid */}
      <div className="row g-4">
        {galleryImages.map((image, index) => (
          <div 
            key={image.id} 
            className="col-lg-4 col-md-6"
          >
            <div className="card h-100 shadow-sm gallery-card">
              <div className="position-relative overflow-hidden">
                <img
                  src={image.src}
                  alt={image.alt}
                  className="card-img-top gallery-image"
                  style={{
                    height: '250px',
                    objectFit: 'cover',
                    cursor: 'pointer',
                    transition: 'transform 0.3s ease'
                  }}
                  onClick={() => openImageModal(image)}
                  onError={(e) => {
                    console.error('❌ Resim yüklenemedi:', image.src);
                    e.target.style.background = '#f8f9fa';
                    e.target.style.display = 'flex';
                    e.target.style.alignItems = 'center';
                    e.target.style.justifyContent = 'center';
                    e.target.alt = 'Resim yüklenemedi';
                  }}
                  onLoad={() => {
                    console.log('✅ Resim başarıyla yüklendi:', image.src);
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'scale(1.05)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'scale(1)';
                  }}
                />
                <div className="position-absolute top-0 end-0 m-2">
                  <button 
                    className="btn btn-primary btn-sm rounded-circle"
                    onClick={() => openImageModal(image)}
                    title="Büyüt"
                  >
                    <i className="bi bi-zoom-in"></i>
                  </button>
                </div>
              </div>

            </div>
          </div>
        ))}
      </div>

      {/* Image Modal */}
      {selectedImage && (
        <div className="gallery-modal" onClick={closeImageModal}>
          <div className="gallery-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="gallery-modal-close" onClick={closeImageModal}>
              <i className="bi bi-x-lg"></i>
            </button>
            
            <button className="gallery-modal-prev" onClick={prevImage}>
              <i className="bi bi-chevron-left"></i>
            </button>
            
            <button className="gallery-modal-next" onClick={nextImage}>
              <i className="bi bi-chevron-right"></i>
            </button>

            <img
              src={selectedImage.src}
              alt={selectedImage.alt}
              className="gallery-modal-image"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
